import { useEffect, useRef } from "react";

import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { useAuthContext } from "@main/context/Auth/Auth.context";
import TagManager from "react-gtm-module";
import { useLocation } from "react-router-dom";

export const useRouteChangeTracker = () => {
  const location = useLocation();
  const { userData } = useAuthContext();
  const { selectedWorkspace } = useAppSelectionContext();
  const previousPathname = useRef<string | null>(null);

  const prevValues = useRef({
    userId: undefined as string | undefined,
    workspaceId: undefined as string | undefined,
  });

  useEffect(() => {
    // Check if any value has actually changed
    const hasChanged =
      prevValues.current.userId !== userData?.id || prevValues.current.workspaceId !== selectedWorkspace?.id;

    // Only track if the pathname actually changed (not just search params or hash)
    if (previousPathname.current !== location.pathname || hasChanged) {
      TagManager.dataLayer({
        dataLayer: {
          event: "user_data",
          user_id: userData?.id,
          workspace_id: selectedWorkspace?.id,
        },
      });

      previousPathname.current = location.pathname;
    }
  }, [location.pathname, userData?.id, selectedWorkspace?.id]);
};
